import { render, staticRenderFns } from "./ClientsWaitingCreate.vue?vue&type=template&id=ca1e94f2&"
import script from "./ClientsWaitingCreate.vue?vue&type=script&lang=js&"
export * from "./ClientsWaitingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports